import ReactPlayer from 'react-player';

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faClose } from '@fortawesome/free-solid-svg-icons';

import { publicUrlStr } from '../../utils';
import * as S from './style';

interface IAudioPlayer {
  audioSource?: string;
  onClose: () => void;
}


//Default: None --> Error
//VideoSource: Audio name WITH file extension!!!
function AudioPlayer({ audioSource, onClose}: IAudioPlayer) {


  const audioUrl = `${publicUrlStr()}/audios/${audioSource}`; //NO url() required!!!

  return (
    <S.Overlay 
      onClick={onClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <ReactPlayer
        url={audioUrl}
        playing
        controls
        volume={1}
        className="contentAudio"
      />
    </S.Overlay>
  );
}

export default AudioPlayer;